import { useContext, useState } from 'react';

import Button from '@ingka/button';
import { Currency, t } from '@onlinepayments/payments-library';

import OrderListItemImage from '../../../../components/OrderItemList/OrderListItemImage';
import { AmountType } from '../../../../enums/AmountType';
import { LineType } from '../../../../enums/LineType';
import { OrderDetailsContext } from '../../../../OrderDetailsContext';
import { PayorderContext } from '../../../../PayorderContext';
import { ofAmountType } from '../../../../utils/misc';
import { OrderSummaryModal } from '../OrderSummaryModal';

import './OrderSummaryHeader.scss';

const PREVIEW_COUNT = 3;

export const OrderSummaryHeader = () => {
  const { order, orderItems } = useContext(OrderDetailsContext);
  const {
    contextState: { amountLeftToPay },
  } = useContext(PayorderContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!order || !orderItems) return null;

  const productItems = orderItems.filter(
    ({ orderLine }) =>
      orderLine?.lineType === LineType.Item || orderLine?.lineType === LineType.Service,
  );
  const previewItems = productItems.slice(0, PREVIEW_COUNT);
  const remainingCount = productItems.length - previewItems.length;

  const totalEntry = order.orderAmounts.find(ofAmountType(AmountType.Total));
  const displayAmount = amountLeftToPay ?? totalEntry?.grossAmount;

  return (
    <div className="OrderSummaryHeader">
      <button
        type="button"
        className="OrderSummaryHeader__title"
        onClick={() => setIsModalOpen(true)}
        data-testid="openOrderSummaryModalFromHeader"
      >
        <span className="OrderSummaryHeader__title-text">
          {t('order_info_header')}
          {displayAmount !== undefined && (
            <>
              {' ('}
              <Currency currency={order.currency} amount={displayAmount} />
              {')'}
            </>
          )}
        </span>
      </button>

      {previewItems.length > 0 && (
        <div className="OrderSummaryHeader__thumbnails">
          {previewItems.map(({ salesItem }) => (
            <div className="OrderSummaryHeader__thumbnail" key={salesItem.itemKey.itemNo}>
              <OrderListItemImage item={salesItem} />
            </div>
          ))}
          {remainingCount > 0 && (
            <Button
              className="OrderSummaryHeader__more"
              type="tertiary"
              size="small"
              text={`+${remainingCount}`}
              aria-label={t('payment.payment_product_list', undefined, {
                numberOfProducts: '' + productItems.length,
              })}
              onClick={() => setIsModalOpen(true)}
              data-testid="openOrderSummaryModalFromHeaderMore"
            />
          )}
        </div>
      )}

      <OrderSummaryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        items={productItems}
        currency={order.currency}
      />
    </div>
  );
};
